module.exports = __webpack_public_path__ + "static/media/Addlayer.db80dd0c.svg";